import firebase from 'firebase';


const firebaseConfig = {
    apiKey: "AIzaSyA6FVev0Os2_L8IVzS_L7KVD8Tlfs99YKw",
    authDomain: "slack-351ad.firebaseapp.com",
    projectId: "slack-351ad",
    storageBucket: "slack-351ad.appspot.com",
    messagingSenderId: "443095136703",
    appId: "1:443095136703:web:d872324af47a7f1db6090a"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig)
  const db = firebaseApp.firestore();
  const auth =firebase.auth();
  const provider = new firebase.auth.GoogleAuthProvider();

  export {auth,provider,db};